// Shared "Explore by …" filter chip (same style across Restaurants/Events/Temples/Party Venues).
export default function FilterChip({
  active,
  onClick,
  color,
  children,
}: {
  active: boolean;
  onClick: () => void;
  color: string;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className="rounded-full border whitespace-nowrap transition-colors shrink-0"
      style={{
        fontFamily: "'Montserrat', sans-serif",
        height: "34px",
        padding: "0 14px",
        fontSize: "12.5px",
        fontWeight: 400,
        background: active ? color : "#ffffff",
        color: active ? "#ffffff" : "#111827",
        borderColor: active ? color : "#e5e7eb",
        boxShadow: "none",
      }}
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.background = "#f0fdf4";
          e.currentTarget.style.borderColor = "#86efac";
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.background = "#ffffff";
          e.currentTarget.style.borderColor = "#e5e7eb";
        }
      }}
    >
      {children}
    </button>
  );
}
